import { h } from "@stencil/core";
import { ElementToggler } from "../../utils";
export class ExpandableItem {
    constructor() {
        this.id = ++ExpandableItem.ID_COUNTER;
        this.onHeaderClick = e => this.toggle(e);
        this.toggler = new ElementToggler('.expandable-item-body');
    }
    async close() {
        if (this.isOpen) {
            this.doClose();
        }
    }
    async open() {
        if (!this.isOpen) {
            this.doOpen();
        }
    }
    toggle(e) {
        e.preventDefault();
        this.isOpen ? this.doClose() : this.doOpen();
        this.expandableOpened.emit(this.isOpen);
    }
    doClose() {
        this.isOpen = false;
        this.toggler.hide(this.el.shadowRoot);
    }
    doOpen() {
        this.isOpen = true;
        this.toggler.show(this.el.shadowRoot);
    }
    render() {
        return (h("li", { key: '9d2bae64daf0c663e0e333ecefd25d702e0ee943', class: {
                'expandable-item': true,
                'expandable-item-open': this.isOpen,
            } }, h("button", { key: '5fc1d9018c7de8995852bc680a30fc723b751023', class: "expandable-item-header", id: `expandable-item-header-${this.id}`, "aria-controls": `expandable-item-body-${this.id}`, "aria-expanded": this.isOpen ? 'true' : 'false', onClick: this.onHeaderClick }, h("oebbx-icon", { key: '85e20ef0bb152e920ac759cb1686b64acb674aa7', name: "triangle", svgStyle: null }), h("slot", { key: 'bf4b93f5d8de07584edcac913398613ebdc4a9ed', name: "header-icon" }), h("slot", { key: '34a3d41b0280d1726c155314005980cafcdb92d1', name: "header" }), h("span", { key: '9830834e2939b1d959cbdbc138e855e7966dc431' }, this.header)), h("div", { key: '82070fb1d55b904bdb6c1c7eac02b134d542af71', class: "expandable-item-body", id: `expandable-item-body-${this.id}`, "aria-labelledby": `expandable-item-header-${this.id}`, "aria-expanded": this.isOpen ? 'true' : 'false', role: "region" }, h("div", { key: '6cef7ddb63ceb742430c433374d0c5a9dc77a471', class: "expandable-item-content" }, h("slot", { key: '4944b39fe5e6217123f522cea359b3cb75f1d1d7' })))));
    }
    static get is() { return "oebbx-expandable-item"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["expandable-item.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["expandable-item.css"]
        };
    }
    static get properties() {
        return {
            "header": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "header",
                "reflect": false
            },
            "isOpen": {
                "type": "boolean",
                "mutable": true,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "is-open",
                "reflect": false
            }
        };
    }
    static get events() {
        return [{
                "method": "expandableOpened",
                "name": "expandableOpened",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                }
            }];
    }
    static get methods() {
        return {
            "close": {
                "complexType": {
                    "signature": "() => Promise<void>",
                    "parameters": [],
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        }
                    },
                    "return": "Promise<void>"
                },
                "docs": {
                    "text": "",
                    "tags": []
                }
            },
            "open": {
                "complexType": {
                    "signature": "() => Promise<void>",
                    "parameters": [],
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        }
                    },
                    "return": "Promise<void>"
                },
                "docs": {
                    "text": "",
                    "tags": []
                }
            }
        };
    }
    static get elementRef() { return "el"; }
}
ExpandableItem.ID_COUNTER = 0;
//# sourceMappingURL=expandable-item.js.map
